var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary lighten-2","small":"","icon":"","disabled":_vm.requestState === 'Loading',"loading":_vm.requestState === 'Loading'},on:{"click":_vm.handleClickExport}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fas fa-file-download")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea597006","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sales/case/ExportCasesAsCsv.vue
// module id = null
// module chunks = 